import React, { useEffect, forwardRef, Fragment } from "react";
import { Button, notification } from 'antd';
import { getModeName } from 'lib';

const Link = (props) => {
  return (
    <Fragment>
      <a href={props.href} target="_blank noopener">
        {props.linkText}
      </a>
    </Fragment>
  )
}

const openNotification = (href, linkText) => {
  notification.info({
    duration: null,
    placement: 'topRight',
    message: "Great job!",
    description: <Link href={href} linkText={linkText} />,
    onClick: () => {
      console.log('Notification Clicked!');
    },
  });
};

export default forwardRef((props: any, ref: any) => {
  const { inputData, language, } = props,
    { questions, toolConfig, } = inputData,
    { href, linkText, } = toolConfig;
    // const href = "https://www.silkmandarin.cn/chinese-culture-training-courses-of-silkmandarin/"
    // const linkText = "Click here to checkout our Culture Course!";
  const isNotComposeMode = getModeName() !== "compose";

  useEffect(() => {
    let isMounted = true;

    if (isNotComposeMode) {
      if (isMounted) setTimeout(openNotification, 1000, href, linkText);
    }

    return () => { isMounted = false }
  }, [])

  return (
    <Fragment></Fragment>
  );
})
